import { Livecourse, LivecourseType } from "./livecourse";

export interface LivecourseDto extends Omit<Livecourse, "startDate" | "endDate"> {
	startDate: string;
	endDate?: string;
	bannerId?: string;
	start_date: string;
	end_date?: string;
}

export function livecourseFromDto(dto: LivecourseDto): Livecourse {
	const now = new Date();
	const startDate = new Date(dto.startDate);
	const endDate = dto.endDate ? new Date(dto.endDate) : undefined;
	const type =
		startDate && startDate > now
			? LivecourseType.SCHEDULED
			: startDate && endDate && now > startDate && now < endDate
				? LivecourseType.INSTANT
				: endDate && now > endDate
					? LivecourseType.OVER
					: LivecourseType.NOT_DEFINED;
	return {
		...dto,
		id: dto.id ?? undefined,
		organization: dto.organization ?? undefined,
		title: dto.title ?? undefined,
		description: dto.description ?? undefined,
		organizer: dto.organizer ?? undefined,
		workspaceId: dto.workspaceId ?? undefined,
		startDate,
		endDate,
		category: dto.category ?? undefined,
		participationLink: dto.participationLink ?? undefined,
		type,
		shareroom: dto.shareroom ?? undefined,
	};
}

export function livecourseToDto(draft: Livecourse): LivecourseDto {
	return {
		...draft,
		bannerId: draft.banner?.id,
		organizer: draft.organizer,
		startDate: draft.startDate.toString(),
		endDate: draft.endDate?.toString(),
	};
}
